import React, { JSX, useEffect, useState} from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    Show,
    SelectArrayInput,
    List,
    TextField,
    NumberField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
    Datagrid,
    EditButton,
    BooleanField,
} from 'react-admin';

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            {/*<FilterButton />*/}
            <ExportButton />
        </TopToolbar>
    );
}


export const WorkflowList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={<ListActions/>}
        >
            <Datagrid bulkActionButtons={false} >
                <TextField source="id" />
                <TextField source="name"  />
                <BooleanField source="enabled" />
                <BooleanField source="isSystem" />
                <EditButton />
            </Datagrid>
        </List>
    );
}
